import React, { useContext, useEffect } from 'react';
import { Box, Stack } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import Images from '../../../../Configs/images';
import AlertContext from '../../../../Context/AlertContext';
import Elements from '../../../Elements';
import MarketIcons from '../../../../Configs/marketIcons';

export default function Component({
  data, classes, error, message,
}) {
  const navigate = useNavigate();
  const { devId } = useParams();

  const { openAlert } = useContext(AlertContext);

  useEffect(() => {
    if (error) {
      openAlert({
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  return (
    <Elements.PageBase navigate={navigate}>
      <div className={classes.root}>
        {data}
      </div>
      <button
        onClick={() => navigate('/home')}
        type="button"
      >
        Home
      </button>
      {devId
        ? (
          <button
            onClick={() => navigate(-1)}
            type="button"
          >
            Back
          </button>
        )
        : (
          <button
            onClick={() => navigate('testParam')}
            type="button"
          >
            Test Param
          </button>
        )}

      <Box p={2}>
        <h4>Assets</h4>
        <Stack gap={1} direction="row" flexWrap="wrap">
          {Object.keys(Images).map((key) => (
            <div key={key} className="center">
              <img alt="icon" src={Images[key]} height={32} width={32} style={{ display: 'inline-block' }} />
              <div className="s-10">{key}</div>
            </div>
          ))}
        </Stack>

        <Box mt={3}>Market Icons</Box>
        <Stack gap={1} direction="row" flexWrap="wrap">
          {Object.keys(MarketIcons).map((key) => (
            <div key={key} className="center">
              <img alt="icon" src={MarketIcons[key]} height={32} width={32} style={{ display: 'inline-block' }} />
              <div className="s-10">{key}</div>
            </div>
          ))}
        </Stack>
      </Box>
    </Elements.PageBase>
  );
}
